// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--AlQ-H";
export var left = "footer-module--left--cfx7e";
export var middle = "footer-module--middle--5YarD";
export var right = "footer-module--right---7eJg";